import axios from 'axios'
import Cookies from 'js-cookie'

// Handle the crazy endpoint conditionals
// TODO: Consumer Env
const instance = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'master'
      ? 'https://prod.amherstapi.com/api/smt/account'
      : process.env.API_BASE_URL_ENV
      ? process.env.API_BASE_URL_ENV === 'local'
        ? 'http://localhost:3000/smt/account'
        : process.env.API_BASE_URL_ENV === 'qa'
        ? 'https://qa.amhev.com/api/smt/account'
        : 'https://qa.amhev.com/api/smt/account'
      : 'https://qa.amhev.com/api/smt/account',
})

// The loginWithPassword endpoint
export const loginWithPassword = async data => {
  let userObj = await instance
    .post('/loginWithPassword', data)
    .then(response => response.data)

  return userObj
}

// The Pecan RE signup endpoint
export const pecanReSignup = async data => {
  let userObj = await instance
    .post('/pecanReSignup', data)
    .then(response => response.data)

  return userObj
}

// The signupWithPassword endpoint
export const signupWithPassword = async data => {
  let userObj = await instance
    .post('/signupWithPassword', data)
    .then(response => response.data)

  return userObj
}

export default {
  instance,
  loginWithPassword,
  pecanReSignup,
  signupWithPassword,
}
